import { apiRequest } from "../index";

export const getOrCreateChatId = async (receiverId) => {
  return apiRequest(`/api/message/chat/find?receiverId=${receiverId}`, "GET");
};

export const createMessage = async ({  chatId, content }) => {
  return apiRequest(`/api/common/messages`, "POST", {
    chatId,
    content,
  });
};

export const getMessages = async (chatId) => {
  return apiRequest(`/api/common/messages/${chatId}`, "GET");
};


export const getOrCreateChatByContext = async ({ contextId, contextType, reason , reasonDetail }) => {
  return apiRequest(
    `/api/common/messages/context/support?contextType=${contextType}&contextId=${contextId}&reason=${encodeURIComponent(reason)}&reasonDetail=${encodeURIComponent(reasonDetail)}`,
    "PUT"
  );
};

export const getAllChats = async (search = "") => {
  const params = new URLSearchParams();
  if (search && search.trim()) {
    params.append("search", search.trim());
  }
  const queryString = params.toString();
  return apiRequest(`/api/common/messages/chats/all${queryString ? `?${queryString}` : ""}`, "GET");
};

export const addParticipant = async ({ chatId, userId, role }) => {
  return apiRequest(`/api/common/messages/chat/add-participant`, "POST", {
    chatId,
    userId,
    role,
  });
};

export const markMessageAsRead = async (chatId) => {
  return apiRequest(`/api/common/messages/chats/read/all/${chatId}`, "GET");
};



